import { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { apiGetOnlineUsers } from '../utils/api';

const OnlineUsersContext = createContext();

export const OnlineUsersProvider = ({ children }) => {
  const { token } = useAuth();
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [onlineCount, setOnlineCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchOnlineUsers = useCallback(async () => {
    if (!token) return;
    try {
      const data = await apiGetOnlineUsers(token);
      setOnlineUsers(data.online_users);
      setOnlineCount(data.count);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch online users:', error);
      setLoading(false);
    }
  }, [token]);

  // Effekt für regelmäßiges Polling (ALLE 10 SEKUNDEN)
  useEffect(() => {
    if (!token) return;
    
    fetchOnlineUsers();
    
    // Poll alle 10 Sekunden (statt 30)
    const interval = setInterval(fetchOnlineUsers, 10000);
    
    return () => clearInterval(interval);
  }, [token, fetchOnlineUsers]);

  return (
    <OnlineUsersContext.Provider value={{ 
      onlineUsers, 
      onlineCount, 
      loading, 
      refetch: fetchOnlineUsers
    }}>
      {children}
    </OnlineUsersContext.Provider>
  );
};

export const useOnlineUsers = () => useContext(OnlineUsersContext);